module.exports = __webpack_public_path__ + "img/sort-up.6363e411.svg";